import TranslatableText from "../../Language/TranslatableText";

export default function NotFound() {
  return (
    <div className="center-align">
      <h3><TranslatableText translationKey="page_not_found" /></h3>
    </div>
  );
}
